module.exports = __webpack_public_path__ + "static/POW-MIA-Papua-New-Guinea-c4094050daadca3efb36dc510bce2a69.jpg";